import { useState, useEffect } from 'react';

// The ~250ms setTimeout/clearTimeout debounce pattern already duplicated
// inline across several form components (VehicleForm.jsx's customer-picker
// autocomplete, ReservationForm.jsx, etc.) -- extracted here once TopNav's
// global search became a second, independent consumer worth sharing code
// with. Existing inline copies are left as-is; this isn't a mass refactor
// of unrelated code.
export function useDebouncedValue(value, delayMs = 250) {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timeout = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timeout);
  }, [value, delayMs]);

  return debounced;
}
